import React, { useEffect, useState } from "react";
import './AppFaq.css';
import './AppFaq-responsive.css';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Ripple } from "primereact/ripple";
import ErrorPage from "../../Components/ErrorPage";
import NoDataCreated from "../../Components/NoDataCreated";
import PageLoader from "../../Components/PageLoader";
import { getAllFaqApi } from "../../Api/SignupApi";
import { Faq, mapFaqs } from "../../Controllers/Types/ApiResponse";

const AppFaq: React.FC = () => {
    const [faqData, setFaqData] = useState<Faq[]>([]);
    const [loadingFaq, setLoadingFaq] = useState<boolean>(false);
    const faqError = '';

    useEffect(() => {
        const getAllFaq = async () => {
            setLoadingFaq(true)
            const res = await getAllFaqApi();
            setLoadingFaq(false)

            if (res.status) {

                setFaqData(mapFaqs(res.body.data));
            }
        }
        getAllFaq();

    }, []);

    return (
        <React.Fragment>
            <div className="main_content layout_padding show_side_bar">
                {loadingFaq ? (
                    <PageLoader />
                ) : faqError ? (
                    <ErrorPage errorMessage={faqError} />
                ) : (
                    <div>
                        <h4 className="main_heading">FAQ</h4>

                        <div className="page_content">
                            {faqData.length > 0 ? (
                                <Accordion activeIndex={-1} className="app_faq_container">
                                    {faqData.map((faq) => (
                                        <AccordionTab
                                            key={faq.id}
                                            header={
                                                <div className="app_faq_header_area">
                                                    <h6 className="first_letter_capitalized">{faq.title}</h6>
                                                    <Ripple pt={{ root: { style: { background: 'rgba(139, 96, 253, 0.2)' } } }} />
                                                </div>
                                            }
                                            className="app_faq_tab"
                                            contentClassName="app_faq_content"
                                            headerClassName="app_faq_header">
                                            <p
                                                className="m-0 first_letter_capitalized"
                                                dangerouslySetInnerHTML={{ __html: faq.details as string }}
                                            />
                                        </AccordionTab>
                                    ))}
                                </Accordion>
                            ) : (
                                <div className="page_main_content_section">
                                    <NoDataCreated message="No data found!" />
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default AppFaq;